var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8646 4.99996V4.33329C13.8646 3.39987 13.8646 2.93316 13.6829 2.57664C13.5231 2.26304 13.2682 2.00807 12.9546 1.84828C12.598 1.66663 12.1313 1.66663 11.1979 1.66663H9.86458C8.93116 1.66663 8.46445 1.66663 8.10793 1.84828C7.79433 2.00807 7.53936 2.26304 7.37957 2.57664C7.19792 2.93316 7.19792 3.39987 7.19792 4.33329V4.99996M8.86458 9.58329V13.75M12.1979 9.58329V13.75M3.03125 4.99996H18.0313M16.3646 4.99996V14.3333C16.3646 15.7334 16.3646 16.4335 16.0921 16.9683C15.8524 17.4387 15.47 17.8211 14.9996 18.0608C14.4648 18.3333 13.7647 18.3333 12.3646 18.3333H8.69792C7.29779 18.3333 6.59772 18.3333 6.06294 18.0608C5.59254 17.8211 5.21008 17.4387 4.9704 16.9683C4.69792 16.4335 4.69792 15.7334 4.69792 14.3333V4.99996",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove2);
export default __webpack_public_path__ + "static/media/remove (2).4d7a0aafeae19e7d65e243deccbc4a08.svg";
export { ForwardRef as ReactComponent };